'use es6';

import { insertDateMessagesWithHistoryConfig } from 'conversations-message-history/dates/operators/insertDateMessagesWithHistoryConfig';
import { createSelector } from '@reduxjs/toolkit';
import { MessageHistoryConfig } from '../constants/MessageHistoryConfig';
import { getFilteredMessages } from './getFilteredMessages';
const displayInitialMessageDate = false;
export const getMessagesList = createSelector([getFilteredMessages], filteredMessages => {
  return insertDateMessagesWithHistoryConfig(filteredMessages, MessageHistoryConfig, displayInitialMessageDate);
});